export const removeScriptFromString = (string: string) =>
  string.replace(/<script.*>.*<\/script>/gi, '')

export const removeTagsFromString = (string: string) =>
  removeScriptFromString(string).replace(/(<([^>]+)>)/gi, '')
